module.exports = __webpack_public_path__ + "static/media/Informe HRT.f162e070.jpg";